import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { Spinner } from 'react-bootstrap';

import {
  FG_3,
  FONT_BODY,
  FONT_SIZE_SMALL,
  FONT_WEIGHT_MEDIUM,
  PRIMARY_COLOR,
} from 'components/upb_viewer_beta/css/betaTokens';

/**
 * BetaSearchLoading — centered spinner + label shown while a search request is
 * in flight. Semantic search takes a moment (query understanding + embedding +
 * vector search + rerank), so we surface an explicit loading state instead of
 * just swapping product tiles.
 */
function BetaSearchLoading({ label }) {
  return (
    <div className={css(styles.box)} role="status" aria-live="polite">
      <Spinner animation="border" style={{ color: PRIMARY_COLOR }} />
      <span className={css(styles.text)}>{label}</span>
    </div>
  );
}

const styles = StyleSheet.create({
  box: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 14,
    padding: '72px 0',
  },
  text: {
    fontFamily: FONT_BODY,
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: FONT_SIZE_SMALL,
    color: FG_3,
  },
});

BetaSearchLoading.propTypes = {
  label: PropTypes.string,
};

BetaSearchLoading.defaultProps = {
  label: 'Searching…',
};

export default BetaSearchLoading;
